import { useState } from "react";
import { useApp } from "@/lib/AppContext";

const CONTACT = {
  phone: "0504175289",
  whatsapp: "966504175289",
};

export default function FloatingContactButtons() {
  const { lang } = useApp();
  const isAr = lang === "ar";
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className="fixed bottom-28 md:bottom-20 z-40 flex flex-col gap-2"
      style={{ [isAr ? "left" : "right"]: "1rem" }}
    >
      {/* Expanded buttons */}
      {expanded && (
        <>
          {/* WhatsApp */}
          <a
            href={`https://wa.me/${CONTACT.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 bg-[#25D366] hover:bg-[#20BA5A] text-white font-bold px-4 py-2.5 rounded-2xl shadow-lg transition-all animate-in slide-in-from-bottom-2"
          >
            <span className="text-xl">📱</span>
            <span className="text-sm whitespace-nowrap">{isAr ? "واتساب" : "WhatsApp"}</span>
          </a>

          {/* Call */}
          <a
            href={`tel:${CONTACT.phone}`}
            className="group flex items-center gap-2 bg-[#007AFF] hover:bg-[#0066D6] text-white font-bold px-4 py-2.5 rounded-2xl shadow-lg transition-all animate-in slide-in-from-bottom-2"
          >
            <span className="text-xl">📞</span>
            <span className="text-sm whitespace-nowrap">{isAr ? "اتصال" : "Call"}</span>
          </a>
        </>
      )}

      {/* Toggle button */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-14 h-14 bg-gradient-to-br from-primary to-accent hover:from-primary/90 hover:to-accent/90 text-white rounded-full shadow-xl flex items-center justify-center transition-all hover:scale-105 active:scale-95"
      >
        {expanded ? (
          <span className="text-2xl">✕</span>
        ) : (
          <span className="text-2xl">📞</span>
        )}
      </button>
    </div>
  );
}